<template>
  <ul>
    <li>
      <el-radio-group v-model="radio" @change="changeHandler">
       <div class="div-tab"><el-radio class="radio" :label="key" :key="key" v-for="(value, key) in radio1" >{{value}}
         <p v-if="key=='GLAD'">羽山人脸</p>
          <p v-if="key=='FACEID'">人脸识别会调用face++通道，但是相应的识别结果记录需要在旧的风控后台查看。</p>
          <p v-if="key == 'RONGXIN'">开启融信通道后，APP1.8.0（包含和以上）版本人脸识别会调用融信进行识别，而旧app版本将继续使用face++通道进行人脸识别。</p>
       </el-radio></div>
      </el-radio-group>
      <br>
    </li>
  </ul>
</template>

<script>
  import URL from '@/views/mis/util/url'
  import Qs from 'qs'
  import axios from 'axios'
  export default {
      data () {
          return {
              radio: 'FACEID',
              radio1:{},
          }
      },
      methods: {
          changeHandler(key) {
              this.$axios.get(URL.face.channelSetChannel, {
                  params:{channel:key}
              }).then((res)=>{
                  if (res.code == 0) {
                      this.initChannel();
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          },
          initChannel() {
              this.$axios.get(URL.face.channelMap, {
                  params:{}
              }).then((res)=>{
                  if (res.code == 0) {
                      let map = res.result;
                      this.radio=map.checkCode;;
                      delete map.checkCode;
                      this.radio1 =map;
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          },
      },
      mounted() {
               this.initChannel();
      }
  }
</script>
<style>
  .div-tab label{
    display: block;
    margin: 20px;
  }
  .div-tab p{
    margin: 10px;
  }
</style>
